"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionFooter = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useQuestionnaireNavigation = require("../../hooks/questionnaire/useQuestionnaireNavigation");
var _services = require("../../services");
var _QuestionHeader = require("./QuestionHeader");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  width: ${props => props.width};
`;
const QuestionFooter = () => {
  var _buttonTheme$appearan, _buttonTheme$appearan2, _buttonTheme$appearan3, _buttonTheme$appearan4, _buttonTheme$appearan5, _buttonTheme$appearan6;
  const {
    onNext,
    onBack,
    isBackVisible,
    isNextEnabled,
    isRestartVisible,
    onRestart
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const nextButtonAppearance = isNextEnabled ? 'primary' : 'secondary';
  const nextButtonState = isNextEnabled ? '' : 'disabled';
  const buttonTheme = (0, _useLocalTheme.default)('button');
  const nextButtonColumns = (0, _useLocalTheme.default)('nextButton.columns', 8);
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const showStickyFooter = (0, _useConfig.default)('uiSettings.showStickyFooter', false);
  const footerMargins = showStickyFooter ? {
    bottom: 6,
    top: 4
  } : {
    bottom: 0,
    top: 0
  };
  const smallFooterWidth = (0, _useLocalTheme.default)('modalBody.smallFooterWidth', '100%');
  const largeFooterWidth = (0, _useLocalTheme.default)('modalBody.footerWidth', '100%');
  const footerWidth = breakpoints.sm ? smallFooterWidth : largeFooterWidth;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    id: "question-footer",
    width: footerWidth
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: footerMargins.bottom,
      top: footerMargins.top
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'center'
  }, isBackVisible ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'between'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan = buttonTheme.appearance) === null || _buttonTheme$appearan === void 0 ? void 0 : _buttonTheme$appearan.alt1,
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-back",
    text: _services.locale.localeString('Questionnaire.ButtonBack'),
    width: 'full',
    appearance: "alt1",
    onClick: onBack
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan2 = buttonTheme.appearance) === null || _buttonTheme$appearan2 === void 0 ? void 0 : _buttonTheme$appearan2[nextButtonAppearance],
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan3 = buttonTheme.appearance) === null || _buttonTheme$appearan3 === void 0 ? void 0 : _buttonTheme$appearan3[nextButtonAppearance],
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan4 = buttonTheme.appearance) === null || _buttonTheme$appearan4 === void 0 ? void 0 : _buttonTheme$appearan4.alt1,
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-back",
    text: _services.locale.localeString('Questionnaire.ButtonBack'),
    width: 'full',
    appearance: "alt1",
    onClick: onBack
  })))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan5 = buttonTheme.appearance) === null || _buttonTheme$appearan5 === void 0 ? void 0 : _buttonTheme$appearan5[nextButtonAppearance],
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: nextButtonColumns
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan6 = buttonTheme.appearance) === null || _buttonTheme$appearan6 === void 0 ? void 0 : _buttonTheme$appearan6[nextButtonAppearance],
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  })))))), isRestartVisible && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "restart-button"
  }, /*#__PURE__*/_react.default.createElement(_QuestionHeader.RestartBtnComponent, {
    isRestartVisible: isRestartVisible,
    onRestart: onRestart,
    placement: "footer"
  })))));
};
exports.QuestionFooter = QuestionFooter;